define.alias("shared/components/shared/ui/search-box/result", "preview-grid/components/shared/ui/search-box/result");